import React, { useEffect, useState, Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Environment, useGLTF } from '@react-three/drei';

function AvatarModel({ modelPath }) {
  const { scene } = useGLTF(modelPath);
  return <primitive object={scene} scale={1.5} />;
}

export default function AvatarViewer() {
  const [avatarUrl, setAvatarUrl] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('token');
  const email = localStorage.getItem('username');

  useEffect(() => {
    const fetchAvatar = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/avatar?email=${encodeURIComponent(email)}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 204) {
          console.warn("No avatar found yet.");
          return;
        }

        const data = await response.json();

        if (response.ok && data.avatarUrl) {
          setAvatarUrl(data.avatarUrl);
        } else {
          console.warn("⚠️ Avatar fetch failed:", data);
        }
      } catch (error) {
        console.error("❌ Failed to load avatar:", error);
      }
    };

    fetchAvatar();
  }, [API_BASE_URL, token, email]);

  if (!avatarUrl) {
    return <p>Loading your avatar...</p>;
  }

  return (
    <div style={{ height: "500px", width: "100%" }}>
      <Canvas camera={{ position: [0, 1.5, 3], fov: 45 }}>
        <ambientLight intensity={0.4} />
        <directionalLight position={[0, 10, 5]} intensity={1} />
        <Suspense fallback={null}>
          <AvatarModel modelPath={avatarUrl} />
          <Environment preset="sunset" />
        </Suspense>
        <OrbitControls enablePan={true} enableZoom={true} />
      </Canvas>
    </div>
  );
}
